import { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

const AdZoneBottom = () => {
    const slides = useMemo(() => ([
        {
            image: "https://cdn.cotik.app/1782192277791_ykxwa2s85h9g4glupf3m_zyjoqqz3p5eh0dvju3y1.png",
            alt: "Cotik warehouse network",
            link: "https://cotik.app/admin/dropshipping/partner-1",
        },
        {
            image: "https://cdn.cotik.app/1782183742967_yw1ght7dewyajya4jj78_5zlyg1wi6vwj4cc4hdi1.png",
            alt: "https://bavorconsulting.com/",
            link: "https://bavorconsulting.com/",
        },
        {
            image: "https://cdn.cotik.app/1782192033654_m8wbpm2nlredxq9ega8t_af2yzcqq0jvuhm1m4v5s.png",
            alt: "https://wordvo.com/",
            link: "https://wordvo.com/",
        },
        {
            image: "https://cdn.cotik.app/1782191921332_injt4shoocylo2c56e89_kqowzyj36s6tyx6uwoks.png",
            alt: "https://t.me/hahahahaa88",
            link: "https://t.me/hahahahaa88",
        },
    ]).slice(0, 5), []);
    const [activeSlide, setActiveSlide] = useState(0);
    const hasMultipleSlides = slides.length > 1;

    useEffect(() => {
        if (!hasMultipleSlides) return;

        const timer = setInterval(() => {
            setActiveSlide((current) => (current + 1) % slides.length);
        }, 5000);

        return () => clearInterval(timer);
    }, [hasMultipleSlides, slides.length]);

    const goToSlide = (index) => {
        setActiveSlide(index);
    };

    const changeSlide = (direction) => {
        setActiveSlide((current) => (current + direction + slides.length) % slides.length);
    };

    if (!slides.length) return null;

    const activeLink = slides[activeSlide]?.link || "#";

    return (
        <div className="adzone-slider card card-body p-0 overflow-hidden">
            <style>
                {`
                    .adzone-slider {
                        position: relative;
                        border: 0;
                        border-radius: 8px;
                        box-shadow: 0 18px 42px rgba(15, 23, 42, 0.08);
                    }

                    .adzone-slider__viewport {
                        position: relative;
                        overflow: hidden;
                        aspect-ratio: 2 / 1;
                        background: #ffffff;
                    }

                    .adzone-slider__track {
                        display: flex;
                        width: 100%;
                        height: 100%;
                        transform: translateX(calc(var(--active-slide) * -100%));
                        transition: transform 620ms cubic-bezier(0.22, 1, 0.36, 1);
                    }

                    .adzone-slider__slide {
                        flex: 0 0 100%;
                        min-width: 100%;
                        height: 100%;
                    }

                    .adzone-slider__image {
                        display: block;
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                        object-position: center;
                    }

                    .adzone-slider__cta {
                        position: absolute;
                        right: 24px;
                        bottom: 22px;
                        z-index: 3;
                        display: inline-flex;
                        align-items: center;
                        gap: 8px;
                        min-height: 42px;
                        padding: 0 18px;
                        overflow: hidden;
                        color: #ffffff;
                        font-weight: 700;
                        border-radius: 6px;
                        background: linear-gradient(135deg, #df0f23 0%, #003a83 100%);
                        box-shadow: 0 12px 24px rgba(0, 38, 92, 0.28);
                        text-decoration: none;
                        transition: transform 180ms ease, box-shadow 180ms ease;
                    }

                    .adzone-slider__cta::before {
                        content: "";
                        position: absolute;
                        inset: -40% auto -40% -55%;
                        width: 42%;
                        transform: rotate(18deg);
                        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.64), transparent);
                        animation: adzoneCtaShine 2.8s ease-in-out infinite;
                    }

                    .adzone-slider__cta:hover {
                        color: #ffffff;
                        transform: translateY(-2px);
                        box-shadow: 0 16px 32px rgba(0, 38, 92, 0.36);
                    }

                    .adzone-slider__cta span,
                    .adzone-slider__cta i {
                        position: relative;
                        z-index: 1;
                    }

                    .adzone-slider__arrow {
                        position: absolute;
                        top: 50%;
                        z-index: 3;
                        width: 34px;
                        height: 34px;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        border: 0;
                        border-radius: 50%;
                        color: #ffffff;
                        background: rgba(8, 18, 38, 0.48);
                        transform: translateY(-50%);
                        transition: background 180ms ease, transform 180ms ease;
                    }

                    .adzone-slider__arrow:hover {
                        background: rgba(8, 18, 38, 0.78);
                        transform: translateY(-50%) scale(1.05);
                    }

                    .adzone-slider__arrow--prev {
                        left: 16px;
                    }

                    .adzone-slider__arrow--next {
                        right: 16px;
                    }

                    .adzone-slider__dots {
                        position: absolute;
                        left: 24px;
                        bottom: 25px;
                        z-index: 3;
                        display: flex;
                        gap: 8px;
                    }

                    .adzone-slider__dot {
                        width: 9px;
                        height: 9px;
                        padding: 0;
                        border: 0;
                        border-radius: 50%;
                        background: rgba(255, 255, 255, 0.58);
                        transition: width 180ms ease, background 180ms ease;
                    }

                    .adzone-slider__dot.active {
                        width: 24px;
                        border-radius: 999px;
                        background: #ffffff;
                    }

                    @keyframes adzoneCtaShine {
                        0% { left: -55%; }
                        46% { left: 125%; }
                        100% { left: 125%; }
                    }

                    @media (max-width: 767.98px) {
                        .adzone-slider__viewport {
                            aspect-ratio: 2 / 1;
                        }

                        .adzone-slider__cta {
                            right: 14px;
                            bottom: 14px;
                            min-height: 36px;
                            padding: 0 14px;
                            font-size: 12px;
                        }

                        .adzone-slider__dots {
                            left: 14px;
                            bottom: 18px;
                        }
                    }
                `}
            </style>
            <div className="adzone-slider__viewport">
                <div className="adzone-slider__track" style={{ "--active-slide": activeSlide }}>
                    {slides.map((slide, index) => (
                        <Link
                            key={`${slide.image}-${index}`}
                            to={slide.link}
                            className="adzone-slider__slide"
                            style={{ textDecoration: "none" }}
                        >
                            <img className="adzone-slider__image" src={slide.image} alt={slide.alt} />
                        </Link>
                    ))}
                </div>

                {hasMultipleSlides && (
                    <>
                        <button type="button" className="adzone-slider__arrow adzone-slider__arrow--prev" onClick={() => changeSlide(-1)} aria-label="Previous banner">
                            <i className="ki-outline ki-left fs-2"></i>
                        </button>
                        <button type="button" className="adzone-slider__arrow adzone-slider__arrow--next" onClick={() => changeSlide(1)} aria-label="Next banner">
                            <i className="ki-outline ki-right fs-2"></i>
                        </button>
                        <div className="adzone-slider__dots">
                            {slides.map((slide, index) => (
                                <button
                                    key={`${slide.image}-dot-${index}`}
                                    type="button"
                                    className={`adzone-slider__dot${activeSlide === index ? " active" : ""}`}
                                    onClick={() => goToSlide(index)}
                                    aria-label={`Go to banner ${index + 1}`}
                                />
                            ))}
                        </div>
                    </>
                )}

                <Link to={activeLink} className="adzone-slider__cta">
                    <span>Tìm hiểu thêm</span>
                    <i className="ki-outline ki-arrow-right fs-3"></i>
                </Link>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AdZoneBottom);
